import { render } from "./BroadcastServiceTimesEditor.vue?vue&type=template&id=3145e5ae&scoped=true"
import script from "./BroadcastServiceTimesEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./BroadcastServiceTimesEditor.vue?vue&type=script&setup=true&lang=js"

import "./BroadcastServiceTimesEditor.vue?vue&type=style&index=0&id=3145e5ae&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3145e5ae"],['__file',"src/components/Sites/Broadcast/BroadcastServiceTimesEditor.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3145e5ae"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3145e5ae', __exports__)) {
    api.reload('3145e5ae', __exports__)
  }
  
  module.hot.accept("./BroadcastServiceTimesEditor.vue?vue&type=template&id=3145e5ae&scoped=true", () => {
    api.rerender('3145e5ae', render)
  })

}


export default __exports__